import { FormElement, FormElementKind } from '@gearbelt/global';

import { initializeTableInitialValues } from './elements/table';
import type { FormRendererData } from './form-elements-renderer';

export function buildPreviewDefaults(elements: FormElement[]): FormRendererData {
  return elements.reduce<FormRendererData>(
    (defaults, element) => ({
      ...defaults,
      [element.id]: element.kind === FormElementKind.Table ? [[...initializeTableInitialValues(element)]] : undefined,
    }),
    {},
  );
}
